module.exports = __webpack_public_path__ + "static/puyonexus-f32f8188bd752e77496a1f1a66f3c6ed.png";